import * as React from 'react';

import styled from 'styled-components';

import PencilIcon from '@components/basics/icons/pencil';
import { rgba } from 'polished';

export interface TitleInputCtrlProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  classNameInput?: string;
  value?: string;
  // active: boolean;
  tabIndex?: number;
  propagateClick?: boolean;
}

let canvas: HTMLCanvasElement;
const getTextWidth = (text: string, maxWidth: number = 0) => {
  if (!canvas) {
    canvas = document.createElement('canvas');
  }

  const left = 4;

  const context = canvas.getContext('2d');
  if (context) {
    context.font = '400 18px nter';
    const metrics = context.measureText(text);
    if (maxWidth && maxWidth < metrics.width) {
      return maxWidth;
    }
    return left + metrics.width;
  }

  return left;
};

export const TitleInputCtrl: React.FC<TitleInputCtrlProps> = (props) => {
  const [width, setWidth] = React.useState(0);
  const [hasFocus, setFocus] = React.useState(false);

  return (
    <div
      className={props.className}
      ref={(el) => setWidth(el?.clientWidth || 0)}
    >
      <input
        className={`editable-input ${hasFocus ? 'has-focus' : ''} ${
          props.classNameInput
        }`}
        id={props.id}
        type={props.type}
        value={props.value}
        placeholder={props.placeholder}
        autoComplete={props.autoComplete}
        tabIndex={props.tabIndex}
        onClick={(ev) => (props.propagateClick ? null : ev.stopPropagation())}
        onChange={(ev) => (props.onChange ? props.onChange(ev) : null)}
        onFocus={(ev) => {
          setFocus(true);
          return props.onFocus ? props.onFocus(ev) : null;
        }}
        onBlur={(ev) => {
          setFocus(false);
          return props.onBlur ? props.onBlur(ev) : null;
        }}
      />
      <PencilIcon
        className="pencil"
        style={{
          left: getTextWidth(props.value || props.placeholder || '', width),
        }}
      />
    </div>
  );
};

export default styled(TitleInputCtrl)`
  position: relative;

  .editable-input {
    font-size: ${({ theme }) => theme.typography.sectionTitle};
    line-height: ${({ theme }) => theme.typography.sectionTitle};
    color: ${({ theme }) => theme.colors.primary};
    background-color: transparent;
    padding: 0;
    width: 100%;
    cursor: pointer;
    background-image: linear-gradient(
      to right,
      transparent 33%,
      ${({ theme }) => rgba(theme.colors.background, 0)} 0%
    );
    transition: background-image
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};

    &.has-focus {
      background-image: linear-gradient(
        to right,
        ${({ theme }) => rgba(theme.colors.border, 0.3)} 33%,
        ${({ theme }) => rgba(theme.colors.background, 0)} 0%
      );
      background-position: bottom;
      background-size: 4px 1px;
      background-repeat: repeat-x;
    }
  }

  .pencil {
    pointer-events: none;
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    opacity: 1;

    @media ${({ theme }) => theme.device.tablet} {
      opacity: 0;
      transition: opacity
        ${({ theme }) =>
          `${theme.transitions.duration} ${theme.transitions.type}`};
    }
  }

  &:hover {
    .pencil {
      opacity: 1;
    }
  }
`;
